import ChatLoader from 'components/ChatLoader'
import store from 'config/store'
import UseStoreSync from 'hooks/UseStoreSync'
import LandingPageLayout from 'layouts/LandingPage'
import React, { Suspense, useEffect }  from 'react'
import { Provider } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { WidgetFrames } from 'shared/constants/frames'
import { listen } from 'utils/message'
import { createAction } from 'utils/redux'

store.name = 'chat' // TODO - make this landing page and get synching working correctly

const LandingPage = () => {
  useEffect(() => {
    UseStoreSync({
      name: WidgetFrames.LANDING_PAGE,
      syncWith: WidgetFrames.CONTROLLER,
      store
    })

    listen({
      topic: 'CONDUCTOR:action-from-plugin',
      handler: ({ data = {} }: { data?: { action?: string, payload?: string } }) => {
        store.dispatch(createAction({
          type: data.action,
          payload: data.payload
        }))
      }
    })

  }, [])

  return (
    <Provider store={store}>
      <Suspense fallback={<ChatLoader />}>
          <LandingPageLayout/>
      </Suspense>
    </Provider>
  )
}

export default withRouter(LandingPage)
